import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

import { provideHttpClient } from "@angular/common/http";
import { provideTranslateService, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, withFetch } from '@angular/common/http';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { environment } from '../environments/environment';
import { importProvidersFrom } from '@angular/core';
import { NgxEditorModule } from 'ngx-editor';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // provideRouter(routes, withDebugTracing()),                     //  Routerのログをコンソールに出力する
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideHttpClient(withFetch()),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'ja',
    }),
    // importProvidersFrom(
    //   NgxEditorModule.forRoot({
    //     locals: {
    //       // menu
    //       bold: 'Bold',
    //       italic: 'Italic',
    //       code: 'Code',
    //       blockquote: 'Blockquote',
    //       underline: 'Underline',
    //       strike: 'Strike',
    //       bullet_list: 'Bullet List',
    //       ordered_list: 'Ordered List',
    //       heading: 'Heading',
    //       h1: 'Header 3',
    //       h2: 'Header 2',
    //       h3: 'Header 3',
    //       h4: 'Header 4',
    //       h5: 'Header 5',
    //       h6: 'Header 6',
    //       align_left: 'Left Align',
    //       align_center: 'Center Align',
    //       align_right: 'Right Align',
    //       align_justify: 'Justify',
    //       text_color: 'Text Color',
    //       background_color: 'Background Color',

    //       // popups, forms, others...
    //       url: 'URL',
    //       text: 'Text',
    //       openInNewTab: 'Open in new tab',
    //       insert: 'Insert',
    //       altText: 'Alt Text',
    //       title: 'Title',
    //       remove: 'Remove',
    //       enterValidUrl: 'Please enter a valid URL',
    //     },
    //   }),
    // ),
  ]
};
